import { api } from '../api';
import { fmtWhen } from '../format';
import { useApp, useLoad } from '../state';
import { useFeedback } from './feedback';
import { Avatar } from './avatar';
import { Icon } from './icons';

// "Needs Andrew": the agents' raised hands. Shown to managers and admins at the top of My day and Team until resolved.
// Each line is in the agent's own words, links to the item, and can be resolved here once the cause is fixed.
export function AlertsStrip() {
  const { can, disclosure } = useApp();
  const { toast } = useFeedback();
  const { data, reload } = useLoad(() => (can('manager') ? api('GET', '/alerts') : Promise.resolve({ alerts: [] })), []);
  const rows: any[] = data?.alerts ?? [];
  if (!can('manager') || !rows.length) return null;
  const resolve = async (a: any) => { try { await api('POST', `/alerts/${a.id}/resolve`, {}); toast('Resolved'); reload(); } catch (e) { toast((e as Error).message, true); } };
  return (
    <section className="card alerts" data-tour="alerts">
      <div className="card-head"><h2><Icon name="alert" className="ico" style={{ color: 'var(--red-700)' }} /> Needs a developer <span className="muted" style={{ fontWeight: 400, fontSize: 14 }}>{rows.length}</span></h2><span className="small muted">Posted to Teams as they happen. Resolve once the cause is fixed; a recurrence reopens it.</span></div>
      {rows.map((a) => (
        <article className="item" key={a.id}>
          {a.agent_code ? <Avatar agentCode={a.agent_code} /> : <span className="av agent" style={{ background: 'var(--navy-3)' }}><Icon name="integrations" /></span>}
          <div style={{ minWidth: 0 }}>
            <div className="head"><h4>{a.title}</h4><span className={`tag ${a.severity === 'error' ? 'late' : 'warn'}`}>{a.severity === 'error' ? 'blocked' : 'waiting'}</span>{a.count > 1 && <span className="tag">×{a.count}</span>}</div>
            <p>{a.body}</p>
            <div className="byline" style={{ marginTop: 8 }}>{a.agent_name && <><b>{a.agent_name}</b><span className="tag ai">{disclosure}</span></>}<span>first {fmtWhen(a.first_seen_at)}{a.count > 1 ? ` · last ${fmtWhen(a.last_seen_at)}` : ''}{a.notified_at ? ' · on Teams' : ' · not yet on Teams'}</span></div>
          </div>
          <div className="acts">{a.work_item_id && <a className="btn quiet sm" href={`#/work/${a.work_item_id}`}>Open item</a>}<button className="sm" onClick={() => resolve(a)}>Resolved</button></div>
        </article>
      ))}
    </section>
  );
}
